export default {
    cities: [],
    selectedCity: {},
    error: false,
    errorMessage: '',
}



// WEBPACK FOOTER //
// ./src/modules/cities/state.js